import { useContext } from 'react';

import { RouteContext } from '../contexts/RouteContext';

function useRoutes() {
  return useContext(RouteContext);
}

export default useRoutes;
